import { getSchema } from '../backend/backend.service';
export function getIdFromFileName(fileName: string) {
    const path = fileName.split("_")[fileName.split("_").length - 1];
    return path.split(".")[0];
}

export async function getSchemaId() {

    try {
       const data = await getSchema();
       return data.data;

    } catch (error) {
        console.log("Error during schema fetch", error)
    }
}